import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { 
  Toolbar, 
  Typography, 
  OutlinedInput, 
  InputAdornment, 
  Icon,
  Box // Added Box for grouping
} from '@mui/material';
import MoreMenu from './more';

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1, 0, 3),
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 600,
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": { 
    width: 700, 
    boxShadow: theme.customShadows.z8 
  },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

// Add styled component for the icon group
const IconGroupStyle = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3), // Small gap between icons
}));

ListToolbarWithSearch.propTypes = {
  selected: PropTypes.array,
  filterName: PropTypes.string,
  label: PropTypes.string,
  selectionOptions: PropTypes.array,
  onOptionSelection: PropTypes.func.isRequired,
  filterOptions: PropTypes.array,
  onFilterName: PropTypes.func,
  exportImportOptions: PropTypes.array
};

export default function ListToolbarWithSearch({
  selected = [], 
  filterName,
  label,
  selectionOptions = [],
  onOptionSelection,
  filterOptions = [],
  onFilterName,
  exportImportOptions = []
}) {
  const hasSelection = selected.length > 0;
  const hasSelectionOptions = selectionOptions && selectionOptions.length > 0;
  const hasFilterOptions = filterOptions && filterOptions.length > 0;
  const hasExportImportOptions = exportImportOptions && exportImportOptions.length > 0;
  
  const shouldShowSelectionMenu = hasSelection && hasSelectionOptions;
  const shouldShowFilterMenu = !hasSelection && hasFilterOptions;
  const shouldShowExportImportMenu = hasExportImportOptions;

  return (
    <RootStyle
      sx={{
        ...(hasSelection && {
          color: "primary.main",
          bgcolor: "primary.lighter",
        }),
      }}
    >
      {/* Left side content */}
      {hasSelection ? (
        <Typography component="strong" variant="title1">
          {selected.length} selected
        </Typography>
      ) : (
        <SearchStyle
          value={filterName}
          onChange={onFilterName}
          placeholder={"Search " + label + "..."}
          startAdornment={
            <InputAdornment position="start">
              <Icon
                children="search"
                sx={{ color: "text.disabled", width: 20, height: 20 }}
              />
            </InputAdornment>
          }
        />
      )}

      {/* Right side icon group */}
      <IconGroupStyle>
        {shouldShowSelectionMenu && (
          <MoreMenu
            selected={selected}
            icon="more_vert"
            onItemSelected={onOptionSelection}
            options={selectionOptions}
          />
        )}
        
        {shouldShowFilterMenu && (
          <MoreMenu
            selected={[]}
            icon="filter_list"
            onItemSelected={() => {}}
            options={filterOptions}
          />
        )}
        
        {shouldShowExportImportMenu && (
          <MoreMenu
            selected={[]}
            icon="import_export"
            onItemSelected={() => {}}
            options={exportImportOptions}
          />
        )}
      </IconGroupStyle>
    </RootStyle>
  );
}